module.exports = __webpack_public_path__ + "static/banner-image-d93c91c22a0dd4f8a563cbd9e8915007.png";